export type block = "block";
export type none  = "none";
export type inline = "inline";
export type inline_block = "inline-block";

//  export\s*type\s*((?:\w|_)+)\s*=\s*"(.+?)";
//    $1 |
export type CSSDisplayType = 
  block | 
  none | 
  inline | 
  inline_block 
;

export class CSSDisplay
{
  //  export\s*type\s*((?:\w|_)+)\s*=\s*"(.+?)";
  //  static readonly $1:$1 = "$2";

  static readonly block:block = "block";
  static readonly none:none = "none";
  static readonly inline:inline = "inline";
  static readonly inline_block:inline_block = "inline-block";
  
}